import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../Service/auth'; // Ajusta la ruta exacta a tu AuthService
import { environment } from '../../environments/environment'; // 👈 IMPORTANTE: Importa tu environment base

/**
 * 🚀 INTERCEPTOR AUTOMÁTICO DE RED SAAS UNIFICADO:
 * 1. Reescribe dinámicamente las rutas relativas (Localhost en desarrollo / IP en producción)
 * 2. Inyecta de forma invisible el token y las cabeceras Multi-Tenant post-login.
 */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const companyUuid = authService.getCompanyId();
  const token = authService.getToken(); 

  // =========================================================================
  // 🗺️ 1. PASO: INYECCIÓN DINÁMICA DE LA URL (SANA LOGIN EN LOCALHOST)
  // =========================================================================
  let finalUrl = req.url;

  // Si la petición no lleva http:// ni https://, le soldamos la IP/Localhost del environment
  if (!req.url.startsWith('http://') && !req.url.startsWith('https://')) {
    const baseUrl = environment.apiUrl.endsWith('/') ? environment.apiUrl.slice(0, -1) : environment.apiUrl;
    const cleanUrl = req.url.startsWith('/') ? req.url : `/${req.url}`;
    finalUrl = `${baseUrl}${cleanUrl}`;
  }

  // =========================================================================
  // 🚪 2. PASO: ACCESO PÚBLICO (PANTALLA DE LOGIN)
  // =========================================================================
  // Si es login u otra petición sin sesión, despachamos modificando SOLO la URL
  if (!companyUuid && !token) {
    const publicReq = req.clone({ url: finalUrl });
    return next(publicReq);
  }

  // =========================================================================
  // 🛡️ 3. PASO: ARMADO DE CABECERAS MULTI-TENANT (POST-LOGIN)
  // =========================================================================
  const headersConfig: { [key: string]: string } = {};

  if (companyUuid) {
    headersConfig['X-Tenant-ID'] = companyUuid;
    headersConfig['x-company-id'] = companyUuid;
  }

  if (token) {
    headersConfig['Authorization'] = `Bearer ${token}`; 
  }

  // Clonamos inyectando la URL corregida Y las cabeceras de seguridad
  const cloneReq = req.clone({
    url: finalUrl,
    setHeaders: headersConfig   
  });

  return next(cloneReq);
};